import { Consultation, Doctor, Patient, Clinic } from '@/types/common';
import { SelectValue } from '@/components/select/types';

import { ISOCalendarDate, ISODateTime } from '@/utils/date/types';
import {BackendSlotCustom, SlotClinic} from '@/api/calendar/backend';

export const enum SlotType {
    Free = 'free',
    Reserved = 'reserved',
    Vacation = 'vacation',
    Request = 'request',
    Highlight = 'highlight',
    PatientChosen = 'patient-chosen',
} 

export const enum ArrowDirection {
    Previous,
    Next,
}

export const enum SlotColor {
    Free = 'grey darken-1',
    Reserved = 'blue',
    Highlighted = 'green',
    Grey = 'grey',
}

export interface TimeEntry {
    start: ISODateTime,
    end: ISODateTime,
}

export interface BaseSlot extends TimeEntry {
    type: SlotType,
    name: string,
}

export interface VacationSlot extends BaseSlot {
    type: SlotType.Vacation,
    dates: TimeEntry,
    vacationId: number,
}

export interface FreeSlot extends BaseSlot {
    type: SlotType.Free,
}

export interface ReservedSlot extends BaseSlot {
    type: SlotType.Reserved,
    consultation: Consultation,
    doctor: Doctor,
    patient: Patient,
    clinic?: Clinic,
}

export interface RequestSlot extends BaseSlot {
    type: SlotType.Request,
}

export interface HighlightSlot extends BaseSlot {
    type: SlotType.Highlight,
}

export interface PatientChosenSlot extends BaseSlot {
    type: SlotType.PatientChosen,
    patient: Patient,
}

export type Slot = FreeSlot | ReservedSlot | VacationSlot | RequestSlot | HighlightSlot | PatientChosenSlot;

export type SlotsMap = Record<ISOCalendarDate, Slot[]>
export type SlotsClinicMap = Record<ISOCalendarDate, SlotClinic[]>
export type SlotsCustomMap = Record<ISOCalendarDate, BackendSlotCustom>

export interface Popup {
    event: Slot,
    activator: HTMLElement,
}

export enum CalendarType {
    Month = 'month',
    Week = 'week',
    Day = 'day',
    List = 'list',
}

export interface ConsultationRequest { 
    startDateTime: string,
    patient: SelectValue,
    specialization: SelectValue,
    medicalServiceType: SelectValue,
    clinic?: SelectValue, // not required
}

export type ConsultationValues = Omit<ConsultationRequest, 'startDateTime'>
